// Widget Closer - Adds close buttons to third-party widgets
(function() {
  'use strict';
  
  // Widget selectors to target - targeting the actual visible elements
  const widgetSelectors = [
    // '.kl-teaser-RwUAPv', // Klaviyo teaser (outermost container)
    '#smile-ui-lite-launcher-frame-container', // Smile.io container
    'inbox-online-store-chat', // Shopify chat element (the actual visible one)
  ];
  
  // Create close button HTML
  function createCloseButton() {
    const closeBtn = document.createElement('div');
    closeBtn.innerHTML = '×';
    closeBtn.setAttribute('aria-label', 'Close widget');
    closeBtn.style.cssText = `
      position: absolute;
      top: 5px;
      right: 5px;
      width: 20px;
      height: 20px;
      background: rgba(0,0,0,0.7);
      color: white;
      border: none;
      border-radius: 50%;
      cursor: pointer;
      font-size: 14px;
      line-height: 20px;
      text-align: center;
      z-index: 999999;
      opacity: 0;
      transition: opacity 0.3s ease;
      user-select: none;
    `;
    
    // Hover effects
    closeBtn.addEventListener('mouseenter', function() {
      this.style.background = 'rgba(0,0,0,0.9)';
    });
    
    closeBtn.addEventListener('mouseleave', function() {
      this.style.background = 'rgba(0,0,0,0.7)';
    });
    
    return closeBtn;
  }
  
  // Add close button to widget
  function addCloseButton(widget) {
    // Skip if already has close button
    if (widget.querySelector('[data-widget-closer]')) return;
    
    const closeBtn = createCloseButton();
    closeBtn.setAttribute('data-widget-closer', 'true');
    
    // Handle click to hide widget
    closeBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      // Fade out both widget and close button
      widget.style.transition = 'opacity 0.3s ease, visibility 0.3s ease';
      closeBtn.style.transition = 'opacity 0.3s ease';
      widget.style.opacity = '0';
      closeBtn.style.opacity = '0';
      
      // After fade completes, hide the widget
      setTimeout(() => {
        // For shadow DOM elements like Shopify chat, use visibility instead of display
        if (widget.tagName.toLowerCase().includes('chat') || widget.shadowRoot) {
          widget.style.visibility = 'hidden';
          widget.style.pointerEvents = 'none';
        } else {
          widget.style.display = 'none';
        }
        closeBtn.remove(); // Remove the close button from DOM
      }, 300);
    });
    
    // Always use fixed positioning for better control
    closeBtn.style.position = 'fixed';
    
    // Calculate position based on widget's position
    const rect = widget.getBoundingClientRect();
    
    // Special positioning for Shopify chat - bottom right corner
    if (widget.tagName.toLowerCase().includes('chat')) {
      closeBtn.style.top = (rect.bottom - 25) + 'px'; // 25px from bottom
      closeBtn.style.left = (rect.right - 15) + 'px'; // 15px from right
    } else {
      // Default positioning - top right corner
      closeBtn.style.top = (rect.top - 5) + 'px';
      closeBtn.style.left = (rect.right - 15) + 'px';
    }
    
    closeBtn.style.zIndex = '9999999999'; // High enough for widgets but below cart drawer
    
    // Add tracking attribute
    closeBtn.setAttribute('data-widget-id', widget.getAttribute('id') || widget.tagName.toLowerCase());
    
    // Always append to body for fixed positioning
    document.body.appendChild(closeBtn);
    
    // Update position on scroll/resize for all widgets
    let positionUpdateId;
    const updatePosition = () => {
      if (positionUpdateId) clearTimeout(positionUpdateId);
      positionUpdateId = setTimeout(() => {
        if (widget.offsetParent !== null || widget.getBoundingClientRect().width > 0) {
          const newRect = widget.getBoundingClientRect();
          
          // Apply same positioning logic as initial setup
          if (widget.tagName.toLowerCase().includes('chat')) {
            closeBtn.style.top = (newRect.bottom - 25) + 'px';
            closeBtn.style.left = (newRect.right - 15) + 'px';
          } else {
            closeBtn.style.top = (newRect.top - 5) + 'px';
            closeBtn.style.left = (newRect.right - 15) + 'px';
          }
        }
      }, 16); // Throttle to ~60fps
    };
    
    window.addEventListener('scroll', updatePosition, { passive: true });
    window.addEventListener('resize', updatePosition, { passive: true });
    
    // Fade in the close button smoothly
    setTimeout(() => {
      closeBtn.style.opacity = '1';
    }, 200); // Slightly longer delay for better effect
  }
  
  // Process widgets
  function processWidgets() {
    widgetSelectors.forEach(selector => {
      try {
        const widgets = document.querySelectorAll(selector);
        widgets.forEach(widget => {
          // More flexible visibility check
          const isVisible = widget && (
            widget.offsetParent !== null || 
            getComputedStyle(widget).display !== 'none' ||
            widget.getBoundingClientRect().width > 0
          );
          
          if (isVisible) {
            // Check if widget is already hidden or has a close button
            const isHidden = widget.style.opacity === '0' || 
                           widget.style.visibility === 'hidden' ||
                           widget.style.display === 'none';
            
            const widgetId = widget.getAttribute('id') || widget.tagName.toLowerCase();
            const hasCloseButton = widget.querySelector('[data-widget-closer]') || 
                                 document.querySelector(`[data-widget-closer][data-widget-id="${widgetId}"]`);
            
            if (!isHidden && !hasCloseButton) {
              addCloseButton(widget);
            }
          }
        });
      } catch (error) {
        console.warn('Widget closer: Error processing selector', selector, error);
      }
    });
  }
  
  // Hide close buttons when cart drawer is open
  function toggleCloseButtonsVisibility() {
    const isCartOpen = document.body.classList.contains('cart-drawer-visible');
    const closeButtons = document.querySelectorAll('[data-widget-closer]');
    
    closeButtons.forEach(btn => {
      if (isCartOpen) {
        btn.style.display = 'none';
      } else {
        btn.style.display = '';
      }
    });
  }
  
  // Initialize after DOM is loaded
  function init() {
    processWidgets();
    
    // Watch for cart drawer opening/closing
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'class') {
          toggleCloseButtonsVisibility();
        }
      });
    });
    
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['class']
    });
    
    // Also check periodically for dynamically loaded widgets
    const intervalId = setInterval(processWidgets, 1000);
    
    // Stop checking after 30 seconds to avoid performance issues
    setTimeout(() => {
      clearInterval(intervalId);
    }, 30000);
  }
  
  // Start when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
})();